import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner, Table, Stack, Container } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import moment from 'moment';
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";

// React Icons Starts Here
import { FiEdit } from "react-icons/fi";
import { FaTrashAlt } from "react-icons/fa";
import { BrowserView } from "react-device-detect";
import CategoryEdit from "./CategoryEdit";
import { formatDate } from "../../utils/helper";
import InfoPill from "../InfoPill";
import Main from "../layout/Main";
//React Icons Ends here.


const CategoryList = () => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [category, setCategory] = React.useState({});
  const [modalShowEditSubject, setModalShowEditSubject] = React.useState(false);


  useEffect(() => {
    console.log('inside the useEffect')
    fetchAllCategory();
  }, []);

  const fetchAllCategory = () => {
    async function init() {
      const financial = await trasportApi.fetchAllCategory();
      if (financial) {
        setBody(financial || []);
      }
    }
    init();
  }



  // Create table headers consisting of 4 columns.
  const header = [
    { title: "Category Name", prop: "name", isFilterable: true },
    {
      title: "Created Date",
      prop: "createddate",
      isSortable: true,
      cell: (row) => <span>{formatDate(row.createddate)}</span>,
    },
    {
      title: "Last Modified Date",
      prop: "lastmodifieddate",
      isSortable: true,
      cell: (row) => <span>{formatDate(row.lastmodifieddate)}</span>,
    },
    // {
    //   title: "Is Active",
    //   prop: "isactive",
    //   cell: (row) => (
    //     <input type="checkbox" checked={row?.isactive? true : false} />
    //   ),
    // },
    // { title: "Is active", prop: "isactive", isFilterable: true },
    // {
    //   title: 'Actions', prop: 'id', cell: (row) => (
    //     <>

    //     </>
    //   )
    // }
  ];

  header.push({
    title: "Actions",
    prop: "id",
    cell: (row) => (
      <div>
        <Button className='btn-sm mx-2 btn-edit' onClick={() => editFinancialYearList(row)}><FiEdit /></Button>
        <Button variant="danger" className='btn-sm mx-2 btn-delete' onClick={() => handleDelete(row)}><FaTrashAlt /></Button>
      </div>
    ),
  });


  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

  const createCategory = () => {
    setCategory({});
    setModalShowEditSubject(true);
  };

  const submitCategoryList = () => {
    setModalShowEditSubject(false);
    fetchAllCategory();
    setCategory({});
  }

  const editFinancialYearList = (row) => {
    setModalShowEditSubject(true);
    setCategory(row);
  }

  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setCategory(row);
  }
  const deleteCategory = async () => {
    console.log("deleteCategory ", category.id)
    const result = await trasportApi.deleteCategory(category.id);
    if (result.success) {
      setCategory('');
      setModalShow(false);
      fetchAllCategory();
    }
  }

  return (
    <>
      <Main>
        {modalShowEditSubject &&
          <CategoryEdit
            show={modalShowEditSubject}
            onHide={() => setModalShowEditSubject(false)}
            submitCategoryList={submitCategoryList}
            category={category ? category : {}}
          />
        }

        {modalShow &&
          <Confirm
            show={modalShow}
            onHide={() => setModalShow(false)}
            deleteCategory={deleteCategory}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="category"
          />}



        <Container fluid>
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20],
              },
            }}
          >

            <Row className="align-items-end">
              <Col
                xs={12}
                lg={4}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={5}
                className="d-flex flex-col justify-content-start align-items-center"
              // md={1} 
              >
                <PaginationOptions labels={labels} md={1} />
                <BrowserView className="mx-5 mt-4">
                  <InfoPill left="Total" right={body?.length} />
                </BrowserView>
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={3}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Stack direction="horizontal" gap={2}>
                  <Button
                    className="btn-create"
                    size="sm"
                    onClick={() => createCategory(true)}
                  >
                    New Category
                  </Button>
                </Stack>
              </Col>
            </Row>

            <Table striped className="shadow rounded sm my-4 data-table" responsive={true}>
              <TableHeader />
              {
                (body && Array.isArray(body)) ?
                  <TableBody />
                  :
                  <tbody className="">
                    <tr>
                      <td colSpan={100} align="center">
                        <div>
                          <Spinner />
                        </div>
                      </td>
                    </tr>
                  </tbody>
              }
            </Table>
            <Pagination classes={{ buttonGroup: "", button: "bg-custom border-white" }} />
          </DatatableWrapper>
        </Container>
      </Main>
    </>
  );
};
export default CategoryList;

